export const notificationsKeys = {
  all: ['notifications'] as const,
  list: (...args: unknown[]) => [...notificationsKeys.all, 'list', ...args] as const,
  item: (id: string) => [...notificationsKeys.all, 'item', id] as const,
  unreadCount: () => [...notificationsKeys.all, 'unreadCount'] as const,
};
